import React from 'react'

function ExploreItem() {
  return (
    <div>
      <section className="explore-item">
        <div className="container expanded">
            <div className="row">
                <div className="col-lg-12">
                    <div className="section-heading">
                        <h2>Minimalistic Design for 2 bedrooms</h2>
                    </div>
                    <div className="main-image">                   
                        <img src="assets/images/explore-item-01.jpg" alt="master bedroom design"/>
                    </div>
                    <div className="project-info">
                        <div className="row">
                            <div className="col-lg-2">
                                <div className="info-item">
                                    <h6>Architect:</h6>
                                    <span>Catherine Rose</span>
                                </div>
                            </div>
                            <div className="col-lg-2">
                                <div className="info-item">
                                    <h6>Client:</h6>
                                    <span>Team</span>
                                </div>
                            </div>
                            <div className="col-lg-2">
                                <div className="info-item">
                                    <h6>Terms:</h6>
                                    <span>6-12 Months</span>
                                </div>
                            </div>
                            <div className="col-lg-2">
                                <div className="info-item">
                                    <h6>Project Type:</h6>
                                    <span>Interior Design</span>
                                </div>
                            </div>
                            <div className="col-lg-2">
                                <div className="info-item">
                                    <h6>Strategy:</h6>
                                    <span>Clean &amp; Minimal</span>
                                </div>
                            </div>
                            <div className="col-lg-2">
                                <div className="info-item">
                                    <h6>Date:</h6>
                                    <span>January 22, 2022</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto toril beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequida nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem.   
                    <br/><br/>This is an Interior Designer HTML5 Template that is 100% totally free to download, edit and use for your commercial or business websites. You are <strong>NOT allowed</strong> to redistribute the downloadable ZIP file of this template on any other website. 
                    Please <a rel="nofollow" href="#" target="_blank">contact our team</a> website for more information. Thank you. <strong>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium</strong>, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis.</p>
                </div>
                <div className="col-lg-6 mb-2">
                    <img className='w-100 h-100' src="assets/images/header.jpg" alt=""/>
                </div>
                <div className="col-lg-6">
                    <img className='w-100 pb-2' src="assets/images/sofa2.jpg" alt=""/>
                </div>
                <div className="col-lg-12">
                    <div className="down-content">
                        <h4>Incredible Work</h4>
                        <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto toril beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequida nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt.</p>
                    </div>
                </div>
                <div className="col-lg-12">
                    <div className="projects-pagination">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="left-pagination">
                                    <img className="float-start" src="assets/images/pagination-left-image.jpg" alt=""/>
                                    <div className="right-content">
                                        <a href="explore.html"><h6>Minimalistic Living Room</h6></a>
                                        <span>Interior Design</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="right-pagination">
                                    <img className="float-end" src="assets/images/pagination-right-image.jpg" alt=""/>
                                    <div className="float-end left-content">
                                        <a href="explore.html"><h6>Futuristic Interior Concept</h6></a>
                                        <span>Interior Design</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </div>
  )
}

export default ExploreItem
